import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Avatar,
  Text,
  Badge,
  Switch,
  VStack,
  HStack,
  Image,
  Button,
  IconButton,
} from "@chakra-ui/react";

import { FiLogOut } from "react-icons/fi";
import LogoutBtnComp from "./LogoutComp";
import { UserAuth } from "../Supabase/context/AuthContext";
import { Link } from "react-router-dom";
import CreditsInfo from "./UserCredit/UserCreditDetails";
import { useSelector } from "react-redux";

export const ProfileCard = ({ isOpen }) => {
  const [usermanage, setUserManage] = useState({});
  const userPlan = useSelector((state) => state.userDetails.userplan);
  const { session, signOut } = UserAuth();

  const token = localStorage.getItem("token");
  const user = session?.user;

  useEffect(() => {
    if (user) {
      setUserManage({
        name:
          user?.user_metadata?.display_name ||
          user?.user_metadata?.name ||
          user?.user_metadata?.full_name ||
          user?.user_metadata?.username,
        email: user?.user_metadata?.email,
        picture:
          user.picture ||
          user?.user_metadata?.picture ||
          user?.user_metadata?.avatar_url,
      });
    }
  }, [user]);

  const trunwords = (text, wordLength) => {
    if (text?.length > wordLength) {
      return text.slice(0, wordLength) + "...";
    }
    return text;
  };

  return (
    <Box
      bg="#232627"
      color="white"
      w="95%"
      p="2"
      margin={"auto"}
      borderRadius="lg"
    >
      {session && user && token && (
        <Flex alignItems="center" gap={2}>
          <Avatar
            w={"30px"}
            h={"30px"}
            p={2}
            name={usermanage?.name}
            src={usermanage?.picture}
            alt={usermanage.name}
            boxSizing={"border-box"}
          />
          <VStack
            display={isOpen ? "block" : "none"}
            align="flex-start"
            spacing={0}
            w={"100%"}
          >
            <HStack w={"100%"} justifyContent={"space-between"}>
              <Text w={"80%"} fontSize={"12px"} fontWeight="bold">
                {trunwords(usermanage?.name, 15)}
              </Text>
              <LogoutBtnComp />
            </HStack>
            <Text fontSize="10px" color="gray.400">
              {usermanage.email}
            </Text>
          </VStack>
        </Flex>
      )}
      <CreditsInfo />
      <Link to="/payment">
        <Box
          display={isOpen ? "block" : "none"}
          border={"1px solid rgba(52, 56, 57, 1)"}
          mt="2"
          py="1"
          textAlign="center"
          borderRadius="md"
          cursor={userPlan === "Enterprise" ? "default" : "pointer"}
          fontSize={"14px"}
          boxSizing={"border-box"}
          _hover={userPlan !== "Enterprise" ? { bg: "gray.600" } : {}}
          pointerEvents={userPlan === "Enterprise" ? "none" : "auto"}
          opacity={userPlan === "Enterprise" ? "0.8" : "1"}
        >
          {userPlan === "Free"
            ? "Upgrade to Standard"
            : userPlan === "Standard"
            ? "Upgrade to Enterprise"
            : "You’re on Enterprise"}
        </Box>
      </Link>

      {/* <Flex justifyContent="space-between" mt="4">
        <Text>Light</Text>
        <Switch colorScheme="teal" size="md" />
        <Text>Dark</Text>
      </Flex> */}
    </Box>
  );
};
